import { Box, IconButton, Progress, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CloseIcon } from "@chakra-ui/icons";
import { useAppDispatch } from "../../../store";
import { clear } from "../../../store/slices/contentSlice";
import { useNavigate, useParams } from "react-router-dom";
import { colors } from "../../../theme/tokens/colors";

type Iprops = {
  title: string;
  progress: number;
  onClick?: () => void;
};

const ModuleHeader = ({ title, progress }: Iprops) => {
  const [isPastThreshold, setIsPastThreshold] = useState(false);
  const { courseId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsPastThreshold(scrollPosition > 48); // 3rem = 48px (assuming 1rem = 16px)
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      h={{ base: "4rem", md: "4.4rem" }}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"space-between"}
      // bg={isPastThreshold ? "background" : "transparent"}
      bgGradient={
        isPastThreshold
          ? `linear(to-b, ${colors.background} 60%, transparent 100%)`
          : "transparent"
      }
    >
      <Box
        cursor={"pointer"}
        onClick={() => {
          dispatch(clear());
          navigate(`/dashboard/course/${courseId}`);
        }}
        p={".5rem"}
      >
        <IconButton
          aria-label="close lesson"
          border={"1px solid white"}
          borderRadius={".9rem"}
          variant={"outline"}
          size={"md"}
          icon={<CloseIcon />}
        ></IconButton>
      </Box>
      <Box display={"flex"} m="auto" maxW={"43rem"} w={"100%"}>
        <Box
          gap={"0.875rem"}
          display={"flex"}
          alignItems={"center"}
          w={"100%"}
          px={"1.5rem"}
        >
          <Tooltip
            hasArrow
            bg={"white"}
            py={".5rem"}
            minWidth={"10rem"}
            textAlign={"center"}
            color={"black"}
            fontSize={"md"}
            label={title}
            offset={[0, 15]}
            borderRadius={".5rem"}
            display={{ base: "none", lg: "block" }}
          >
            <Progress
              size={{ base: "sm", lg: "md" }}
              outlineOffset={".3rem"}
              sx={{
                cursor: "pointer",
              }}
              colorScheme="green"
              value={progress}
              width={"100%"}
            />
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default ModuleHeader;
